module.exports = __webpack_public_path__ + "img/price-credit-win-icon.1d0b1251.png";